// ============================================
// JKS JEWELS - Static Data
// ============================================

export const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '/about-us' },
  // { label: 'Jewellery', href: '#jewellery' },
  // { label: 'Gold Purchase Plans', href: '#gold-plans' },
   { label: 'Our Products', href: '#jewellery' },
  { label: 'Contact Us', href: '/contact-us' },
];

export const FEATURES = [
  {
    id: 1,
    icon: 'wholesale',
    title: 'Wholesale Making Charge',
    desc: 'Exclusive Wholesale Making Charges crafted to give you more value for every purchase.',
  },
  {
    id: 2,
    icon: 'exchange',
    title: 'Best Exchange Value',
    desc: 'We offer best exchange value for any old gold, allows you to get whole new gold ornament collection.',
  },
  {
    id: 3,
    icon: 'buyback',
    title: '100% Buyback',
    desc: 'We guarantee 100% buyback for all our diamond, precious & uncut diamond jewellery.',
  },
  {
    id: 4,
    icon: 'purity',
    title: '100% Purity',
    desc: 'Our gold jewellery holds BIS 916 hallmark certification, We guarantee purity to our customers.',
  },
];

export const EXCLUSIVE_COLLECTIONS = [
  {
    id: 1,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1601121141418-9f9e8d8a1b8d?w=600&q=80',
    alt: 'Diamond Necklace Collection',
  },
  {
    id: 2,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=600&q=80',
    alt: 'Gold Ring Collection',
  },
  {
    id: 3,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1635767798638-3e25273a8236?w=600&q=80',
    alt: 'Diamond Earrings',
  },
  {
    id: 4,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1573408301185-9519f94f27e1?w=600&q=80',
    alt: 'Gold Bangles',
  },
];

export const NEW_COLLECTIONS = [
  {
    id: 1,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1603899122634-f086ca5f5ddd?w=600&q=80',
    alt: 'Solitaire Diamond Collection',
    wide: true,
  },
  {
    id: 2,
    label: 'JKS Collections',
    image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=600&q=80',
    alt: 'Gold Jewels Collection',
    wide: false,
  },
];

export const FAQS = [
    {
    id: 1,
    question: 'Are all gold ornaments at JKS Jewels HUID 916 hallmarked and BIS certified?',
    answer: 'Absolutely. All our gold jewellery carries the BIS 916 hallmark certification along with HUID (Hallmark Unique Identification). This guarantees 91.6% gold purity — the highest standard available — and full traceability for every piece.',
  },
  {
    id: 2,
    question: 'Does JKS Jewels offer assured lifetime maintenance for gold and diamond jewellery?',
    answer: 'Yes, we offer lifetime maintenance services including cleaning, polishing, and minor repairs for all jewellery purchased from JKS Jewels. Simply visit any of our showrooms with your original purchase receipt.',
  },
  {
    id: 3,
    question: 'Does JKS Jewels offer online shopping?',
    answer: 'Currently, JKS Jewels operates primarily through our showrooms in Kolkata to provide a personalized luxury experience. For inquiries, you may contact us through our website and our team will assist you.',
  },
  {
    id: 4,
    question: 'Are there current offers or discounts at JKS Jewels?',
    answer: 'JKS Jewels regularly offers seasonal promotions, wedding specials, and exclusive member benefits. Visit our showrooms or subscribe to our newsletter to stay updated on the latest offers.',
  },
  {
    id: 5,
    question: 'What is the gold rate at JKS Jewels today?',
    answer: 'Gold rates are updated daily at all our showrooms in line with market prices. Please visit your nearest JKS Jewels showroom or call us for the current day\'s rate. We ensure complete transparency in pricing.',
  },
];

export const FOOTER_LINKS = {
  other: [
    { label: 'Blogs', href: '#' },
    { label: 'Terms & Conditions', href: '#' },
    { label: 'Privacy Policy', href: '#' },
    { label: 'Refund/Cancellation Policy', href: '#' },
    { label: 'JKS Care', href: '#' },
  ],
};

export const SOCIAL_LINKS = [
  { platform: 'facebook', href: 'https://www.facebook.com/profile.php?id=61591714923067' },
  { platform: 'instagram', href: 'https://www.instagram.com/jksjewelspvtltd/' },
  { platform: 'youtube', href: 'https://www.youtube.com/channel/UCEPdi-t_7QmVTzjEWnefNjg' },

];

export const MARQUEE_ITEMS = [
  'Specializing in Antique and Temple jewellery',
  'Highly Skilled Workers',
  '1st Jewellery Company in Karnataka',
  'Exclusive Designs',
  'BIS hallmarked gold',
  'Easy exchange & buyback policies',
  'Bridal & wedding collections',
  'Skilled artisans',
  'modern technology',
  'Unique designs',
  'Strict quality control',
  'Latest trends blended ',
];
